import type {
	IGiftProvider,
	IWishListItem
} from "~/types/supabase";
import type {
	Photos
} from "~/types/typeDefinitions";

export const imageDataStores = () => {
	const giftProviders = useState<IGiftProvider[]>( "gift-providers", () => [] );
	const wishListItems = useState<IWishListItem[]>( "wishlist-items", () => [] );
	const homePhotos = useState<Photos[]>( "home-photos", () => [] );
	const photoPagePhotos = useState<Photos[]>( "photo-page-photos", () => [] );
	const ourStoryPhotos = useState<Photos[]>( "our-story-photos", () => [] );
	const thingsToDoPhotos = useState<Photos[]>( "things-to-do-photos", () => [] );
	const weddingPartyPhotos = useState<Photos[]>( "wedding-party-photos", () => [] );
	const inspirationPhotos = useState<{ dress: Photos[]; suit: Photos[] }>( "inspiration-photos", () => {
		return {
			dress: [],
			suit: []
		};
	} );
	const contentLoaded = useState<boolean>( "content-loaded", () => false );

	return {
		giftProviders,
		wishListItems,
		homePhotos,
		photoPagePhotos,
		ourStoryPhotos,
		thingsToDoPhotos,
		weddingPartyPhotos,
		inspirationPhotos,
		contentLoaded
	};
};